export default __webpack_public_path__ + "static/media/EditSubject.8bf48942.mp4";